module.exports = __webpack_public_path__ + "img/full3-min.aaf231b3.png";